// prettier-ignore
export default "filecheck"